import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	description: {
		id: `eoc.team-dashboard.sidebar.header.description.no-translate`,
		defaultMessage: 'Operations',
		description: 'Description of project',
	},
});

export default messages;
